import { ToastOptions } from 'react-toastify'

import { SHOW_TOAST } from '../types/toast'

export const showToast = (msg: string, type: string, options?: ToastOptions) => {
  return { type: SHOW_TOAST, payload: { msg: msg, type: type, ...options } }
}
